module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dev', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('item', {
      key: "index",
      attrs: {
        "passed-item": item,
        "type": _vm.type
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-421a3ccc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Data.vue
// module id = 10
// module chunks = 0